export default __webpack_public_path__ + "static/media/header_mobile_m.96fea061.png";